import { TServiceCookie } from 'features/product-info/components/pdp-select-tint-color';

type TProps = {
  parsedServicesFromCookies: TServiceCookie[];
  productCode: string;
  tintServiceIds: string[];
};

export const getTintServicesFromCookies = ({
  parsedServicesFromCookies,
  productCode,
  tintServiceIds,
}: TProps) => {
  return parsedServicesFromCookies.filter((service) => {
    return (
      service.parentLineId === productCode &&
      tintServiceIds.includes(service.id.toString()) &&
      'hex' in service &&
      !!service.hex &&
      'color' in service.parameters &&
      !!service.parameters.color
    );
  });
};
